import React, { useState, useEffect } from 'react';
import './MarcasCarousel.css';

const PUBLIC_URL = process.env.PUBLIC_URL || '';

const MarcasCarousel = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev === 0 ? 1 : 0));
    }, 7000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="marcas-carousel-container">
      <div
        className="marcas-carousel-track"
        style={{ transform: `translateX(-${currentSlide * 100}%)` }}
      >
        <div className="marcas-carousel-slide">
          <div className="marcas-carousel-item">
            <img
              src={`${PUBLIC_URL}/images/Marcas/Stulz.svg`}
              alt="Stulz"
              className="marca-carousel-logo marca-carousel-logo-stulz"
            />
          </div>
          <div className="marcas-carousel-item">
            <img
              src={`${PUBLIC_URL}/images/Marcas/siemens.svg`}
              alt="Siemens"
              className="marca-carousel-logo marca-carousel-logo-siemens"
            />
          </div>
          <div className="marcas-carousel-item">
            <img
              src={`${PUBLIC_URL}/images/Marcas/Centiel.png`}
              alt="Centiel"
              className="marca-carousel-logo marca-carousel-logo-centiel"
            />
          </div>
        </div>
        <div className="marcas-carousel-slide marcas-carousel-slide-four">
          <div className="marcas-carousel-item">
            <img
              src={`${PUBLIC_URL}/images/Marcas/disano.svg`}
              alt="Disano"
              className="marca-carousel-logo"
            />
          </div>
          <div className="marcas-carousel-item marcas-carousel-item-nvent">
            <img
              src={`${PUBLIC_URL}/images/Marcas/nvent.svg`}
              alt="nVent"
              className="marca-carousel-logo marca-carousel-logo-nvent"
            />
          </div>
          <div className="marcas-carousel-item">
            <img
              src={`${PUBLIC_URL}/images/Marcas/LS.svg`}
              alt="LS"
              className="marca-carousel-logo marca-carousel-logo-ls"
            />
          </div>
          <div className="marcas-carousel-item">
            <img
              src={`${PUBLIC_URL}/images/Marcas/inatra.svg`}
              alt="Inatra"
              className="marca-carousel-logo"
            />
          </div>
        </div>
      </div>
      <div className="marcas-carousel-dots">
        <button
          type="button"
          className={`marcas-carousel-dot ${currentSlide === 0 ? 'active' : ''}`}
          onClick={() => setCurrentSlide(0)}
          aria-label="Slide 1"
        />
        <button
          type="button"
          className={`marcas-carousel-dot ${currentSlide === 1 ? 'active' : ''}`}
          onClick={() => setCurrentSlide(1)}
          aria-label="Slide 2"
        />
      </div>
    </div>
  );
};

export default MarcasCarousel;
